import {
	CheckboxInput,
	Label,
	Select,
	TextInput,
	TimeInput,
} from 'components/Form'
import Table from 'components/Table/index'
import notification from 'helpers/notification'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import services from 'services/index'
import { defaultFormData } from '../constants'

const CreateForm = () => {
	const navigate = useNavigate()
	const [disabled, setDisabled] = useState(false)
	const [createData, setCreateData] = useState(defaultFormData)
	const [teachers, setTeachers] = useState([])
	const [students, setStudents] = useState([])
	const [search, setSearch] = useState('')

	const handleSelectAll = () => {
		const selectedAll = students.map(item => item.id)
		if (createData?.students?.length === students?.length) {
			setCreateData({ ...createData, students: [] })
		} else {
			setCreateData({ ...createData, students: selectedAll })
		}
	}
	const handleSelect = id => {
		if (createData?.students?.includes(id)) {
			setCreateData({
				...createData,
				students: createData?.students?.filter(item => item !== id),
			})
		} else {
			const newStudentsList = [...createData?.students, id]
			setCreateData({ ...createData, students: newStudentsList })
		}
	}
	const headersModal = [
		{
			key: 'checkbox',
			label: (
				<CheckboxInput
					type='checkbox'
					value={createData?.students?.length === students?.length}
					onChange={handleSelectAll}
					className='w-4 h-4'
				/>
			),
			width: '50px',
			getContent: ({ data }) => (
				<CheckboxInput
					type='checkbox'
					value={createData?.students?.some(item => item === data.id)}
					onChange={() => handleSelect(data?.id)}
					className='w-4 h-4'
				/>
			),
		},
		{
			key: 'first_name',
			label: 'Ism',
			getContent: ({ data, key, index }) => {
				const name = data?.first_name
				return <div className='text-start'>{name}</div>
			},
		},
		{
			key: 'last_name',
			label: 'Familiya',
			getContent: ({ data, key, index }) => {
				const name = data?.last_name
				return <div className='text-start'>{name}</div>
			},
		},
		{
			key: 'student_class',
			label: 'Sinf',
			getContent: ({ data, key, index }) => {
				const date = data?.student_class || '-'
				return <div className='text-start'>{date}</div>
			},
		},
		{
			key: 'phone_number',
			label: 'Otasining telefon raqami',
			getContent: ({ data, key, index }) => {
				const phone = data?.phone_number || '-'
				return <div className='text-start'>{phone}</div>
			},
		},
		{
			key: 'phone_number',
			label: 'Onasining telefon raqami',
			getContent: ({ data, key, index }) => {
				const phone = data?.phone_number2 || '-'
				return <div className='text-start'>{phone}</div>
			},
		},
	]
	const weekDay = id => {
		const isSelectDay = createData?.weekdays?.includes(id)
		isSelectDay
			? setCreateData({
					...createData,
					weekdays: createData?.weekdays?.filter(item => item !== id),
			  })
			: setCreateData({
					...createData,
					weekdays: [...createData?.weekdays, id],
			  })
	}
	const getTeachers = () => {
		const options = {
			filter: { page: 1, page_size: 1000 },
			onError: () => setTeachers([]),
			onSuccess: response => {
				const newData = []
				const results = response?.data?.results
				results?.map(item =>
					newData?.push({
						label: item?.first_name + ' ' + item?.last_name,
						value: item?.id,
					})
				)
				setTeachers(newData)
			},
		}
		services.teachers.getTeachers(options)
	}
	const getStudents = () => {
		const options = {
			filter: { page: 1, page_size: 10000, search },
			onError: () => setStudents([]),
			onSuccess: response => {
				const results = response?.data?.results
				setStudents(results)
			},
		}
		services.students.getStudents(options)
	}
	useEffect(() => {
		getTeachers()
		getStudents()
	}, [search])
	const createGroup = () => {
		const options = {
			data: createData,
			onStart: () => setDisabled(true),
			onError: error => notification('Error', { type: 'error' }),
			onEnd: () => setDisabled(false),
			onSuccess: response => {
				if (response?.status === 201) {
					setCreateData(defaultFormData)
					navigate('/account/groups')
					notification('Guruh muvaffaqiyatli yaratildi!', {
						type: 'success',
					})
				} else {
					notification('Error', { type: 'error' })
				}
			},
		}
		services.groups.createGroups(options)
	}
	return (
		<div className='pt-6'>
			<div className='grid grid-cols-12 gap-4 mb-6'>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Guruh nomi</Label>
					<TextInput
						size='small'
						value={createData?.name}
						onChange={name => setCreateData({ ...createData, name })}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>O’qituvchi</Label>
					<Select
						size='small'
						options={teachers}
						value={teachers?.find(item => item?.value === createData?.teachers)}
						onChange={({ value }) =>
							setCreateData({ ...createData, teachers: value })
						}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>To’lov summasi</Label>
					<TextInput
						size='small'
						value={createData?.price}
						onChange={price => setCreateData({ ...createData, price })}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Dars vaqti</Label>
					<div className='grid grid-cols-2 gap-4'>
						<TimeInput
							size='small'
							placeholder='Boshlanish vaqti'
							value={createData?.start_time}
							onChange={start_time =>
								setCreateData({ ...createData, start_time })
							}
						/>
						<TimeInput
							size='small'
							placeholder='Tugash vaqti'
							value={createData?.end_time}
							onChange={end_time => setCreateData({ ...createData, end_time })}
						/>
					</div>
				</div>
				<div className='col-span-12 sm:col-span-8'>
					<Label>Hafta kunlari</Label>
					<div className='flex flex-wrap flex-col sm:flex-row gap-6 mt-2.5'>
						<div className='flex items-center gap-2'>
							<CheckboxInput
								size='small'
								value={createData?.weekdays?.includes('0')}
								onChange={() => weekDay('0')}
							/>
							<span className='text-[14px] text-[#292A32] dark:text-[#ffffff] leading-none'>
								Dushanba
							</span>
						</div>
						<div className='flex items-center gap-2'>
							<CheckboxInput
								size='small'
								value={createData?.weekdays?.includes('1')}
								onChange={() => weekDay('1')}
							/>
							<span className='text-[14px] text-[#292A32] dark:text-[#ffffff] leading-none'>
								Seshanba
							</span>
						</div>
						<div className='flex items-center gap-2'>
							<CheckboxInput
								size='small'
								value={createData?.weekdays?.includes('2')}
								onChange={() => weekDay('2')}
							/>
							<span className='text-[14px] text-[#292A32] dark:text-[#ffffff] leading-none'>
								Chorshanba
							</span>
						</div>
						<div className='flex items-center gap-2'>
							<CheckboxInput
								size='small'
								value={createData?.weekdays?.includes('3')}
								onChange={() => weekDay('3')}
							/>
							<span className='text-[14px] text-[#292A32] dark:text-[#ffffff] leading-none'>
								Payshanba
							</span>
						</div>
						<div className='flex items-center gap-2'>
							<CheckboxInput
								size='small'
								value={createData?.weekdays?.includes('4')}
								onChange={() => weekDay('4')}
							/>
							<span className='text-[14px] text-[#292A32] dark:text-[#ffffff] leading-none'>
								Juma
							</span>
						</div>
						<div className='flex items-center gap-2'>
							<CheckboxInput
								size='small'
								value={createData?.weekdays?.includes('5')}
								onChange={() => weekDay('5')}
							/>
							<span className='text-[14px] text-[#292A32] dark:text-[#ffffff] leading-none'>
								Shanba
							</span>
						</div>
						<div className='flex items-center gap-2'>
							<CheckboxInput
								size='small'
								value={createData?.weekdays?.includes('6')}
								onChange={() => weekDay('6')}
							/>
							<span className='text-[14px] text-[#292A32] dark:text-[#ffffff] leading-none'>
								Yakshanba
							</span>
						</div>
					</div>
				</div>
			</div>
			<div className='flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-3'>
				<h3 className='text-[18px] lg:text-[22px] text-[#292A32] dark:text-[#ffffff] font-semibold'>
					O'quvchilarni tanlang
				</h3>
				<div className='max-w-full sm:max-w-[300px]'>
					<TextInput
						size='small'
						placeholder='Izlash...'
						value={search}
						onChange={value => setSearch(value)}
					/>
				</div>
			</div>
			<Table
				data={students}
				headers={headersModal}
				isLoading={false}
				emptyMessage="Ma'lumot topilmadi"
				withPadding={true}
			/>
			<div className='flex justify-center sm:justify-end mt-4'>
				<button
					disabled={disabled}
					className='success-btn w-full sm:w-auto'
					onClick={createGroup}
				>
					Guruh yaratish
				</button>
			</div>
		</div>
	)
}

export default CreateForm
